import { AbstractControl, ValidationErrors } from '@angular/forms';

import { ApDigipasService } from '../digipas.service';

export class ApValidDigipasValidator {
    /** {@inheritDoc}. */
    public static validate(control: AbstractControl): ValidationErrors | null {
        return !control.value || ApValidDigipasValidator.isValid(control.value) ? null : { digipas: true };
    }

    /**
     * Indicates if the given digipas is valid.
     *
     * @param digipas The digipas.
     * @return valid Indicator valid.
     */
    private static isValid(digipasInput: string): boolean {
        // implementation based on php and c++ implementation in EB
        // http://slpa14281.unix.bank.local/lib/exe/fetch.php?media=eb:secure_pages:check_digit_digipas.pdf
        const digipas: string = ApDigipasService.formatDigipasId(digipasInput);
        const value = digipas.substring(0, digipas.length - 1);
        const checkdigit = Number(digipas[digipas.length - 1]);
        if (value.length === 7 || value.length === 9) {
            let o = 0;
            let e = 0;
            for (let i = 0; i < value.length; i++) {
                if (i % 2 === 0) {
                    e += Number(value[i]);
                } else {
                    o += Number(value[i]);
                }
            }
            e = e * 3;
            const r = o + e;
            for (let i = 0; i < 10; i++) {
                if ((r + i) % 10 === 0) {
                    return i === checkdigit;
                }
            }
        }
        return false;
    }
}
